<template>
  <div class="tipsMask" :type="type" :style="'background:' + this.bgColor">
    <img src="../assets/img/draw_noright.png" width="170" height="170" />
    <p>{{ $l(text) }}</p>
  </div>
</template>

<script>
// import global from "@/mixins/global.js";
export default {
  name: "tipsMask",
  // mixins: [global],
  props: {
    text: {
      type: String,
      default: "暂无数据",
    },
    type: {
      type: String,
      default: "noright",
    },
    bgColor: String,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
  watch: {
    // text (val) {
    // }
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tipsMask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(#fff, 1);
  color: $--color-text-regular;
  img {
    margin-top: -15px;
  }
  p {
    margin-top: -8px;
  }
}
</style>
